import { FormattedMessage } from 'components/shared/Intl';
import { FC } from 'react';

import type { UnderlyingResultTableProps } from '../Common';
import { getTableLength } from '../Common';

export const CreditUnderlyingResultTable: FC<UnderlyingResultTableProps> = ({ options, children }) => {
  const displayedResultsCount = getTableLength(options);

  return (
    <table className="table table-sm table-hover border-default" data-e2e="underlying-result-panel">
      <thead>
        <tr>
          <FormattedMessage id="name" tagName="th" />
          <FormattedMessage id="underlying.CCY" tagName="th" />
          <FormattedMessage id="underlying.seniorityType" tagName="th" />
        </tr>
      </thead>
      <tbody>{children}</tbody>
      {displayedResultsCount < options.length && (
        <tfoot>
          <tr>
            <td colSpan={3}>{`+ ${options.length - displayedResultsCount}...`}</td>
          </tr>
        </tfoot>
      )}
    </table>
  );
};
